<app-detail-main-template>
  <div container-header>
    <app-detail-header-template>
      <div top-left>
        <div class="header bold">APPROVE PURSUITS</div>
      </div>
      <div bottom-left *ngIf="showAttestationForm">
        <div class="sub-menu__container--pursuits">
          <div class="item">
            <a class="link" [ngClass]="{'active': isApproval}" (click)="toggleTab('approvals')">
              <div class="button">
                <div class="description">Approvals</div>
              </div>
            </a>
          </div>
          <div class="item">
            <a class="link" [ngClass]="{'active': isForms}" (click)="toggleTab('forms')">
              <div class="button">
                <div class="description">Attestation Form</div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </app-detail-header-template>
  </div>
  <div container-body>
    <div *ngIf="isApproval">
      <app-approval-center-grid [url]="url"
                                [stateName]="stateName"
                                [additionalColumns]="additionalColumns"
                                [additionalFilters]="additionalFilters"
                                [approvalRequestType]="approvalRequestType"
                                [viewAttributeId]="viewAttributeId"
                                [showViews]="true">
      </app-approval-center-grid>  
    </div>
    <div *ngIf="isForms">
      <app-attestation-pursuit-grid [approvalRequestType]="approvalRequestType">
      </app-attestation-pursuit-grid>
    </div>
  </div>
</app-detail-main-template>